export default "__VITE_ASSET__BI6UXtX8__"